import Component from "@base/js/component";
import debounce from "../../base/js/util/debounce";
import breakpoint from "../../base/js/util/breakpoint";

export default class FeaturedExperts extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".featured-experts";

  // Defines children that needs to be queried as part of this component
  static children = {
    cardArray: [".featured-experts__card"],
    cards: ".featured-experts__cards",
    next: ".featured-experts__slider-next",
    previous: ".featured-experts__slider-previous",
    navigation: ".featured-experts__slider-navigation",
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    // subComponent: ComponentClass, // Maps as a single subcomponent instance
    // subComponents: [ComponentClass], // Maps as an array of subcomponent instances
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    next: {
      click: this.slideNext,
    },
    previous: {
      click: this.slidePrevious,
    },
    // body: {
    //  click: this.onBodyClick // Attaches onBodyClick method to this.children.body
    // }
  };

  constructor() {
    super();
    this.slideIndex = 0;
    this.lastBreakpoint = null;
  }

  slideNext() {
    this.initiateSlide(1);
  }

  slidePrevious() {
    this.initiateSlide(-1);
  }

  initiateSlide(direction) {
    const { cardArray, cards, next, previous } = this.children;
    const cardStyle = getComputedStyle(cardArray[0]);
    const { marginRight, width } = cardStyle;
    const cardWidth = parseFloat(marginRight, 10) + parseFloat(width, 10);
    const cardsDisplayed = cards.clientWidth / cardWidth;
    const slidesCount = Math.ceil(cardArray.length / cardsDisplayed);

    /* eslint-disable no-console */
    if (
      direction === 1 &&
      slidesCount > this.slideIndex &&
      this.slideIndex + 1 < cardArray.length
    ) {
      this.slideIndex += 1;
    } else if (direction === -1 && this.slideIndex > 0) {
      this.slideIndex -= 1;
    } else {
      return;
    }

    if (
      this.slideIndex === slidesCount ||
      this.slideIndex + 1 === cardArray.length
    ) {
      next.setAttribute("disabled", true);
    } else {
      next.removeAttribute("disabled");
    }

    if (this.slideIndex === 0) {
      previous.setAttribute("disabled", true);
    } else {
      previous.removeAttribute("disabled");
    }

    cards.style.left = `${this.slideIndex * -1 * cardWidth}px`;
  }

  handleNavigation() {
    const { cardArray, navigation } = this.children;

    if (cardArray.length === 2) {
      navigation.classList.add("no-tablet");
    } else if (cardArray.length < 2) {
      navigation.remove();
    }
  }

  // Will be called upon component instantiation
  afterInit() {
    const { cardArray, cards, previous, next } = this.children;
    const cardStyle = getComputedStyle(cardArray[0]);
    const { marginRight, width } = cardStyle;
    const cardWidth = parseFloat(marginRight, 10) + parseFloat(width, 10);

    this.handleNavigation();

    window.addEventListener(
      "resize",
      debounce(() => {
        if (breakpoint() !== this.lastBreakpoint) {
          cards.removeAttribute("style");
          next.removeAttribute("disabled");
          previous.setAttribute("disabled", true);
          this.slideIndex = 0;
          this.lastBreakpoint = breakpoint();
        } else {
          cards.style.left = `${this.slideIndex * -1 * cardWidth}px`;
        }
      }, 100)
    );

    /* eslint-disable no-console */
    console.log(`Component initialized`, this.element);
    /* eslint-enable no-console */
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
FeaturedExperts.init();
